var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeniusLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 80,
    viewBox: "0 0 258 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7881 35.1699L22.2109 35.1699L24.4229 39L22.2109 42.8301L17.7881 42.8301L15.5762 39L17.7881 35.1699Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7881 63.1699L63.2109 63.1699L65.4229 67L63.2109 70.8301L58.7881 70.8301L56.5762 67L58.7881 63.1699Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2881 67.0361L74.7109 67.0361L76.4229 70L74.7109 72.9639L71.2881 72.9639L69.5762 70L71.2881 67.0361Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2881 26.0361L60.7109 26.0361L62.4229 29L60.7109 31.9639L57.2881 31.9639L55.5762 29L57.2881 26.0361Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2881 5.03613L51.7109 5.03613L53.4229 8L51.7109 10.9639L48.2881 10.9639L46.5762 8L48.2881 5.03613Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5381 47.835L26.4609 47.835L27.4229 49.5L26.4609 51.165L24.5381 51.165L23.5762 49.5L24.5381 47.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5381 58.835L27.4609 58.835L28.4229 60.5L27.4609 62.165L25.5381 62.165L24.5762 60.5L25.5381 58.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5381 48.835L46.4609 48.835L47.4229 50.5L46.4609 52.165L44.5381 52.165L43.5762 50.5L44.5381 48.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5381 42.835L56.4609 42.835L57.4229 44.5L56.4609 46.165L54.5381 46.165L53.5762 44.5L54.5381 42.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5381 38.835L62.4609 38.835L63.4229 40.5L62.4609 42.165L60.5381 42.165L59.5762 40.5L60.5381 38.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5381 48.835L66.4609 48.835L67.4229 50.5L66.4609 52.165L64.5381 52.165L63.5762 50.5L64.5381 48.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5381 57.835L67.4609 57.835L68.4229 59.5L67.4609 61.165L65.5381 61.165L64.5762 59.5L65.5381 57.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5381 73.835L67.4609 73.835L68.4229 75.5L67.4609 77.165L65.5381 77.165L64.5762 75.5L65.5381 73.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5381 64.835L50.4609 64.835L51.4229 66.5L50.4609 68.165L48.5381 68.165L47.5762 66.5L48.5381 64.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5381 57.835L46.4609 57.835L47.4229 59.5L46.4609 61.165L44.5381 61.165L43.5762 59.5L44.5381 57.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5381 20.835L31.4609 20.835L32.4229 22.5L31.4609 24.165L29.5381 24.165L28.5762 22.5L29.5381 20.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5381 12.835L27.4609 12.835L28.4229 14.5L27.4609 16.165L25.5381 16.165L24.5762 14.5L25.5381 12.835Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0781 13.7676L86.9209 13.7676L87.4551 15L86.9209 16.2324L86.0781 16.2324L85.5439 15L86.0781 13.7676Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0781 18.7676L73.9209 18.7676L74.4551 20L73.9209 21.2324L73.0781 21.2324L72.5439 20L73.0781 18.7676Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0781 18.7676L48.9209 18.7676L49.4551 20L48.9209 21.2324L48.0781 21.2324L47.5439 20L48.0781 18.7676Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0781 45.7676L84.9209 45.7676L85.4551 47L84.9209 48.2324L84.0781 48.2324L83.5439 47L84.0781 45.7676Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0781 76.7676L72.9209 76.7676L73.4551 78L72.9209 79.2324L72.0781 79.2324L71.5439 78L72.0781 76.7676Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07812 58.7676L3.9209 58.7676L4.45508 60L3.9209 61.2324L3.07812 61.2324L2.54395 60L3.07812 58.7676Z",
    fill: "#2AD2C9",
    stroke: "#2AD2C9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8496 24.3086L48.1494 24.3086L54.251 34.5L48.1494 44.6914L35.8496 44.6914L29.748 34.5L35.8496 24.3086Z",
    stroke: "#2AD2C9",
    strokeWidth: 3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3486 25.1748L80.6504 25.1748L86.25 34.5L80.6504 43.8252L69.3486 43.8252L63.749 34.5L69.3486 25.1748Z",
    stroke: "#2AD2C9",
    strokeWidth: 3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0771 50.2061L17.9219 50.2061L21.8447 57L17.9219 63.7939L10.0771 63.7939L6.1543 57L10.0771 50.2061Z",
    stroke: "#2AD2C9",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0771 18.2061L21.9219 18.2061L25.8447 25L21.9219 31.7939L14.0771 31.7939L10.1543 25L14.0771 18.2061Z",
    stroke: "#2AD2C9",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0771 9.20605L64.9219 9.20605L68.8447 16L64.9219 22.7939L57.0771 22.7939L53.1543 16L57.0771 9.20605Z",
    stroke: "#2AD2C9",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0771 49.9375L80.9219 49.9375L83.8447 55L80.9219 60.0625L75.0771 60.0625L72.1543 55L75.0771 49.9375Z",
    stroke: "#2AD2C9",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0771 7.9375L41.9219 7.9375L44.8447 13L41.9219 18.0625L36.0771 18.0625L33.1543 13L36.0771 7.9375Z",
    stroke: "#2AD2C9",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07715 35.9375L9.92187 35.9375L12.8447 41L9.92187 46.0625L4.07715 46.0625L1.1543 41L4.07715 35.9375Z",
    stroke: "#2AD2C9",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5771 51.8037L38.4219 51.8037L40.8447 56L38.4219 60.1963L33.5771 60.1963L31.1543 56L33.5771 51.8037Z",
    stroke: "#2AD2C9",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5771 51.8037L58.4219 51.8037L60.8447 56L58.4219 60.1963L53.5771 60.1963L51.1543 56L53.5771 51.8037Z",
    stroke: "#2AD2C9",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M102.407 70V49.5669H116.312V53.7441H107.604V58.4028H115.505V62.3818H107.604V70H102.407ZM120.136 70V49.5669H134.14V53.7441H125.333V57.8223H133.616V61.6455H125.333V65.8228H134.14V70H120.136ZM138.572 70V49.5669H152.577V53.7441H143.769V57.8223H152.053V61.6455H143.769V65.8228H152.577V70H138.572ZM157.009 70V49.5669H165.59C171.679 49.5669 175.148 53.1919 175.148 59.564V59.5923C175.148 66.29 171.735 70 165.59 70H157.009ZM162.206 65.8228H164.655C168.025 65.8228 169.852 63.7271 169.852 59.6914V59.6631C169.852 55.8682 167.926 53.7441 164.655 53.7441H162.206V65.8228ZM186.646 70.5522C181.548 70.5522 178.348 68.23 178.136 64.4351L178.122 64.1802H183.078L183.092 64.3076C183.233 65.5679 184.635 66.4741 186.731 66.4741C188.756 66.4741 190.087 65.5537 190.087 64.251V64.2368C190.087 63.0898 189.181 62.5518 186.788 62.0845L184.678 61.6738C180.359 60.8384 178.49 58.7993 178.49 55.6133V55.5991C178.504 51.5918 181.902 49.0146 186.604 49.0146C191.729 49.0146 194.519 51.606 194.831 55.2168L194.845 55.3867H190.03L190.002 55.2168C189.79 53.9424 188.515 53.0928 186.632 53.0928C184.763 53.0928 183.658 53.9282 183.658 55.146V55.1602C183.658 56.3213 184.593 56.9585 186.802 57.3975L188.912 57.8081C193.259 58.6577 195.241 60.3994 195.241 63.6987V63.7129C195.241 67.8901 192.027 70.5522 186.646 70.5522Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M113.879 38.7617C105.207 38.7617 99.9922 33.1562 99.9922 23.8984V23.8594C99.9922 14.7188 105.227 9.05469 113.684 9.05469C120.559 9.05469 125.656 13.0781 126.379 18.8203L126.398 19.0156H119.328L119.289 18.8398C118.684 16.4766 116.516 14.9922 113.684 14.9922C109.68 14.9922 107.277 18.3125 107.277 23.7812V23.8203C107.277 29.3867 109.934 32.8242 114.035 32.8242C117.297 32.8242 119.543 30.9102 119.738 28.0195L119.758 27.5508H114.602V22.6289H126.672V26.2617C126.672 34.0156 121.848 38.7617 113.879 38.7617ZM132.023 38V9.81641H151.34V15.5781H139.191V21.2031H150.617V26.4766H139.191V32.2383H151.34V38H132.023ZM157.453 38V9.81641H163.176L174.934 25.6758H175.285V9.81641H182.082V38H176.398L164.602 21.9844H164.25V38H157.453ZM188.742 38V9.81641H195.91V38H188.742ZM214.68 38.7617C207.355 38.7617 202.57 34.6016 202.57 28.2734V9.81641H209.719V27.5898C209.719 30.8711 211.496 32.8242 214.699 32.8242C217.922 32.8242 219.68 30.8711 219.68 27.5898V9.81641H226.828V28.2734C226.828 34.582 222.102 38.7617 214.68 38.7617ZM243.996 38.7617C236.965 38.7617 232.551 35.5586 232.258 30.3242L232.238 29.9727H239.074L239.094 30.1484C239.289 31.8867 241.223 33.1367 244.113 33.1367C246.906 33.1367 248.742 31.8672 248.742 30.0703V30.0508C248.742 28.4688 247.492 27.7266 244.191 27.082L241.281 26.5156C235.324 25.3633 232.746 22.5508 232.746 18.1562V18.1367C232.766 12.6094 237.453 9.05469 243.938 9.05469C251.008 9.05469 254.855 12.6289 255.285 17.6094L255.305 17.8438H248.664L248.625 17.6094C248.332 15.8516 246.574 14.6797 243.977 14.6797C241.398 14.6797 239.875 15.832 239.875 17.5117V17.5312C239.875 19.1328 241.164 20.0117 244.211 20.6172L247.121 21.1836C253.117 22.3555 255.852 24.7578 255.852 29.3086V29.3281C255.852 35.0898 251.418 38.7617 243.996 38.7617Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeniusLogo);
export default __webpack_public_path__ + "static/media/genius-logo.b488c139463ef006ac0ff00979bfb50e.svg";
export { ForwardRef as ReactComponent };